import React, { useState } from "react";
import { Turnstile } from "@marsidev/react-turnstile";
import { firebaseAuth } from "../firebase";
import { authAPI } from "../services/api";
import logo from "../assets/logo.webp";
import "../styles/Register.css";

const TURNSTILE_SITE_KEY = "0x4AAAAAACohYrDRnmpigBMD";

const Register = () => {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [turnstileToken, setTurnstileToken] = useState(null);

    const handleRegister = async () => {
        setErrorMessage("");
        if (!name || !email || !password) {
            setErrorMessage("❌ يرجى ملء جميع الحقول.");
            return;
        }

        if (!turnstileToken) {
            setErrorMessage("❌ يرجى إكمال التحقق الأمني أولاً.");
            return;
        }

        const strongRegex = new RegExp("^(?=.*[A-Za-z])(?=.*\\d).{8,}$");
        if (!strongRegex.test(password)) {
            setErrorMessage("❌ كلمة المرور يجب أن تتكون من 8 أحرف على الأقل، وتحتوي حرفاً ورقماً واحداً على الأقل.");
            return;
        }

        setIsLoading(true);

        try {
            // 1. Create User in Firebase
            await firebaseAuth.signUp(email, password);

            // 2. Sync with Backend (MySQL) to create teacher profile with full name
            await authAPI.syncUser("teacher", name);

            // ✅ Force reload to ensure App.js picks up the new Pending status
            window.location.href = "/dashboard";
        } catch (error) {
            let msg = error.message;
            if (msg.includes("email-already-in-use")) msg = "البريد الإلكتروني مستخدم بالفعل.";
            setErrorMessage(msg);
            setTurnstileToken(null); // ✅ إعادة تعيين التحقق عند الفشل
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="register-container">
            <img src={logo} alt="لوغو دارس" className="auth-logo" style={{ width: "150px", marginBottom: "20px", display: "block", marginLeft: "auto", marginRight: "auto" }} />
            <h2 style={{ textAlign: "center" }}>✍️ تسجيل معلم جديد</h2>
            <input type="text" placeholder="👤 الاسم الكامل" value={name} onChange={(e) => setName(e.target.value)} disabled={isLoading} />
            <input type="email" placeholder="📧 البريد الإلكتروني" value={email} onChange={(e) => setEmail(e.target.value)} disabled={isLoading} />
            <input type="password" placeholder="🔑 كلمة المرور" value={password} onChange={(e) => setPassword(e.target.value)} disabled={isLoading} />

            {/* ✅ Cloudflare Turnstile - التحقق من البشر */}
            <div style={{ margin: "12px 0", display: "flex", justifyContent: "center" }}>
                <Turnstile
                    siteKey={TURNSTILE_SITE_KEY}
                    onSuccess={(token) => {
                        setTurnstileToken(token);
                        setErrorMessage("");
                    }}
                    onExpire={() => setTurnstileToken(null)}
                    onError={() => setErrorMessage("❌ خطأ في التحقق الأمني، حاول مجدداً.")}
                    options={{ language: "ar", theme: "auto" }}
                />
            </div>

            {errorMessage && <p className="error-message">{errorMessage}</p>}
            <button onClick={handleRegister} disabled={isLoading}>
                {isLoading ? "⏳ جارٍ التحميل..." : "🚀 إنشاء حساب"}
            </button>
        </div>
    );
};

export default Register;
